export default "__VITE_ASSET__BhZO5S5o__"